import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '.../../environments/environment';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { utils, write, WorkBook } from 'xlsx';
import { saveAs } from 'file-saver';
import { AuthService } from '../../_services';
import { process, State, aggregateBy } from '@progress/kendo-data-query';
import { GroupDescriptor, DataResult } from '@progress/kendo-data-query';
import { Observable } from 'rxjs/Observable';
import { SelectableSettings, DataStateChangeEvent, GridDataResult } from '@progress/kendo-angular-grid';
import { LoaderService } from '../../_services/loader.service';
import Swal from 'sweetalert2'
import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
const moment = _rollupMoment || _moment;
import {ThemePalette} from '@angular/material/core';

export const MY_FORMATS = {
    parse: {
        dateInput: 'LL',
    },
    display: {
        dateInput: 'LL',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};


@Component({
    selector: 'complete-dashboard',
    templateUrl: 'completeDashboard.component.html',
    providers: [
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
})

export class CompleteDashboardComponent {
    dailyUccCollection = []
    dailyCollection: any
    dashboardCard: any
    yesterdayData: any
    public value: number = 10;
    todayDataUcc: any
    arrowUp: any
    percentInc: any
    percentDec: any
    amountMtd: any
    householdMtd: any
    topPerformerName: any
    topPerformerAmount: any
    uccCollector: any
    labelContent: any
    public netWeight = 0
    public totalCNT = 0
    public total = 0
    public totalPending = 0
    public totalResolved = 0
    public prjcd: any
    public totalToday = 0
    public totalPendingToday = 0
    public totalResolvedToday = 0
    public totalMTD = 0
    public totalPendingMTD = 0
    public totalResolvedMTD = 0
    public startDateMTD: any
    public todayFeedBack = 0
    public todayObser = 0
    public today: any
    complainData: any
    complainDataList: any;
    defaultStartDate: any
    defaultEndDate: any
    dateRangeModal: any
    public todayData: any
    public customData: any
    public mtdData: any
    prjId: any;
    totalComplain: any;
    todayTotal: any;
    totPending: any;
    totResolved: any;
    public totalCustFeedBack = 0;
    public totalCustUnderOb = 0;
    complainChartList: any;
    public startDate: any;
    public endDate: any;
    dataNotFound = false;
    chartNotFound = false;
    public showLoader: boolean
    customDataNotFound = false;
    customChartNotFound = false
    custMtdFeedBack = 0
    custMtdUnderObser = 0
    public aggregates: any[] = [{ field: 'Total', aggregate: 'sum' }, { field: 'Today', aggregate: 'sum' }, { field: 'Pending', aggregate: 'sum' }, { field: 'Resolved', aggregate: 'sum' }, { field: 'FeedBack', aggregate: 'sum' }, { field: 'UnderObservation', aggregate: 'sum' }];
    public state: State = {
        skip: 0,
        take: 50,
        filter: {
        logic: 'and',
        filters: []
        }
    };
    public pageSize: any
    public checkboxOnly = false;
    public mode = 'multiple';
    public selectableSettings: SelectableSettings;
    public groups: GroupDescriptor[] = [];
    public view: Observable<GridDataResult>;
    public gridCollectorData: DataResult;
    public gridCollectorDataNull: DataResult;
    
    zoneWiseHousehold: boolean;
    zoneWiseCollection: boolean;
    ZonehhOnly: boolean;
    ZoneuccOnly: boolean;
    ZonehhAnducc: boolean;

    dayWiseHousehold: boolean;
    dayWiseCollection: boolean;
    DayWisehhOnly: boolean;
    DayWiseuccOnly: boolean;
    DayWisehhAnducc: boolean;
    isLoadedZone: boolean = false;
    isLoaded: boolean = false;
    isLoadedDay: boolean = false;
    isLoadedCards: boolean = false;
    yesterdayTotal: any;
    nullZoneData = [];
    todayAmount: any;
    yesterdayAmount: any;
    percentIncAmt: number;
    percentDecAmt: number;
    arrowUpAmt: boolean;
    maxAxis: any;
    minAxis = 0;
    amountArray = []
    totalHouseArray = []
    dateArray = []
    zoneWiseAmountArray = []
    zoneWiseTotalHouseArray = []
    zonesArray = []
    queryType: string = 'ZoneWise';
    tableName: string = 'Zone wise';

    public groupChange(groups: GroupDescriptor[]): void {
        this.groups = groups;
        this.loadProducts();
    }
    public complainTypeData: any
    public complainZoneWiseData: any
    public complainMonthWiseData: any
    private loadProducts(): void {
        this.gridCollectorData = process(this.uccCollector, { group: this.groups });
        this.gridCollectorDataNull = process(this.nullZoneData, { group: this.groups });
    }

    entityType = [
        { id : 1, name : 'Zone Wise', value : 'ZoneWise'},
        { id : 2, name : 'Ward Wise', value : 'WardWise'}
    ]

    public series: any[] = [ 
        {
            type: 'column',
            data: [],
            name: 'Total Household',
            color: '#ec5e0a',
            axis: 'hh'
        }, {
            type: 'line',
            data: [],
            name: 'UCC Collection',
            color: '#4e4141',
            axis: 'amount'
        }
    ];
    
    public valueAxes: any[] = [
        {
            name: 'hh',
            title: 'Total household covered',
            color: '#ec5e0a',
            position : 'end'
        },
        {
            name: 'amount',
            title: 'Total UCC Collection',
            color: '#4e4141',
            position : 'start'
        }
    ];
    
    public categories: string[] = [];

    // zone wise
    public zoneWiseSeries: any[] = [ 
        {
            type: 'column',
            data: [],
            name: 'Total Household',
            color: '#ec5e0a',
            axis: 'hh'
        }, {
            type: 'line',
            data: [],
            name: 'UCC Collection',
            color: '#4e4141',
            axis: 'amount'
        }
    ];

    public zoneWiseValueAxes: any[] = [
        {
            name: 'hh',
            title: 'Total household covered',
            color: '#ec5e0a',
            position : 'end'
        },
        {
            name: 'amount',
            title: 'Total UCC Collection',
            color: '#4e4141',
            position : 'start'
        }
    ];

    public zoneWiseCategories: string[] = [];

    constructor(private http: HttpClient, private auth: AuthService, private loaderService: LoaderService) {
        this.loaderService.status.subscribe((val: boolean) => {
          this.showLoader = val;
        });
        var date = new Date();
        var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        this.defaultStartDate = (firstDay.getFullYear()) + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate();
        this.defaultEndDate = (date.getFullYear()) + '-' + (date.getMonth() + 1) + '-' + date.getDate();
        this.dateRangeModal = { beginDate: { year: firstDay.getFullYear(), month: firstDay.getMonth() + 1, day: firstDay.getDate() }, endDate: { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() } };
        this.startDateMTD = (firstDay.getFullYear()) + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate();
        this.today = (date.getFullYear()) + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    }
    
    
    // Zone wise collection
    uccDailyCollectionEntityWise() {
        this.clearDataZoneWise();
        this.isLoadedZone = true
        let stdate = moment(this.defaultStartDate).format('YYYY-MM-DD');
        let enddate = moment(this.defaultEndDate).format('YYYY-MM-DD');
        console.log(this.queryType);
        
        this.http.get(environment.apiUrl + 'ucc/uccDailyCollectionEntityWise?prjId=' + this.prjId + "&queryType=" + this.queryType + "&fromDate=" + stdate + "&toDate=" + enddate).subscribe(data => {
            var zonewisedata : any;
            zonewisedata = data
            var zoneName
            var zoneNumber
            for(var i = 0; i < zonewisedata.length; i++){
                if(zonewisedata[i].EntityName != null){
                    this.dailyUccCollection.push(zonewisedata[i])
                }
                else {
                    this.nullZoneData.push(zonewisedata[i])
                    this.gridCollectorDataNull = process(this.nullZoneData, this.state);
                }

//                 var str = "Ward-20";
// var str_sub = str.substr(str.lastIndexOf("-")+0);

                zoneName = this.dailyUccCollection[i].EntityName.substring(0,1)
                zoneNumber = this.dailyUccCollection[i].EntityName.substring(this.dailyUccCollection[i].EntityName.lastIndexOf("-")+0)
                zoneName += zoneNumber

                this.zoneWiseAmountArray.push(this.dailyUccCollection[i].Amount)
                this.zoneWiseTotalHouseArray.push(this.dailyUccCollection[i].TotalHouseholds)
                this.zonesArray.push(zoneName)
            }      
            this.zoneWiseSeries[0].data = this.zoneWiseTotalHouseArray
            this.zoneWiseSeries[1].data = this.zoneWiseAmountArray
            this.zoneWiseCategories = this.zonesArray
            this.isLoadedZone = false
        })
    }
  
    queryFilter (data){
        this.queryType = null
        if (data == null) {
            this.queryType = 'ZoneWise'
            this.tableName = 'Zone wise'
        } else {
            this.queryType = data.value
            if (this.queryType == 'ZoneWise') {
                this.tableName = 'Zone wise'
            } else {
                this.tableName = 'Ward wise'
            }
        }
        this.uccDailyCollectionEntityWise()
    }
    // day wise collection
    uccDailyCollection() {
        this.clearDataDayWise();
        this.isLoadedDay = true
        let stdate = moment(this.defaultStartDate).format('YYYY-MM-DD');
        let enddate = moment(this.defaultEndDate).format('YYYY-MM-DD');
        this.http.get(environment.apiUrl + 'ucc/uccDailyCollection?prjId=' + this.prjId + "&fromDate=" + stdate + "&toDate=" + enddate).subscribe(data => {
            this.dailyCollection = data
            this.bindCard(this.dailyCollection)
            this.isLoadedDay = false
            
            for (let i = 0; i < this.dailyCollection.length; i++) {
                let date = this.dailyCollection[i].date
                let dayOnly = date.substring(0, 2);
                this.dailyCollection[i].dateAndMonth = dayOnly
                this.amountArray.push(this.dailyCollection[i].amount)
                this.totalHouseArray.push(this.dailyCollection[i].total)
                this.dateArray.push(this.dailyCollection[i].date.substring(0, 2))
            }
            this.series[0].data = this.totalHouseArray
            this.series[1].data = this.amountArray
            this.categories = this.dateArray
        })
    }
  
    // top collector
    getTopPerformer() {
        let stdate = moment(this.defaultStartDate).format('YYYY-MM-DD');
        let enddate = moment(this.defaultEndDate).format('YYYY-MM-DD');
        this.http.get(environment.apiUrl + 'ucc/topPerformer?prjId=' + this.prjId + "&fromDate=" + stdate + "&toDate=" + enddate).subscribe(data => {
            var topPerformer = data[0]
            this.topPerformerName = topPerformer.collectorName
            this.topPerformerAmount = topPerformer.amount
        })
    }

    // collection and hh by Collector name
    collectionBycollectorName() {
        this.isLoaded = true
        let stdate = moment(this.defaultStartDate).format('YYYY-MM-DD');
        let enddate = moment(this.defaultEndDate).format('YYYY-MM-DD');
        this.http.get(environment.apiUrl + 'ucc/collectionBycollectorName?prjId=' + this.prjId + "&fromDate=" + stdate + "&toDate=" + enddate).subscribe(data => {
            this.uccCollector = data
            this.gridCollectorData = process(this.uccCollector, this.state);
            this.isLoaded = false
        });
    }

    clearDataDayWise(){
        this.dailyCollection = null
        this.totalHouseArray = []
        this.amountArray = []
        this.dateArray = []
        this.series[0].data = []
        this.series[1].data = []
        this.categories = []
    }

    clearDataZoneWise(){
        this.dailyUccCollection = []
        this.zoneWiseTotalHouseArray = []
        this.zoneWiseAmountArray = []
        this.zonesArray = []
        this.zoneWiseSeries[0].data = [] 
        this.zoneWiseSeries[1].data = []  
        this.zoneWiseCategories = []
    }

  importUccMobileReport(data) {
    const ws_name = 'importUccMobileReport';
    const wb: WorkBook = { SheetNames: [], Sheets: {} };
    const ws: any = utils.json_to_sheet(data);
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;
    const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' });
    saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), 'uccReport.xlsx');
  }

  s2ab(s) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xFF;
    };
    return buf;
  }

  bindCard(data) {
    this.isLoadedCards = true
    this.yesterdayData = data[data.length - 2]
    this.todayDataUcc = data[data.length - 1]

    this.todayTotal = this.todayDataUcc.total
    this.todayAmount = this.todayDataUcc.amount
    
    if(this.yesterdayData){
      this.yesterdayTotal = this.yesterdayData.total
      this.yesterdayAmount = this.yesterdayData.amount
    } else {
      this.yesterdayTotal = 'N/A'
      this.yesterdayAmount = 'N/A'
    }
    
    if (this.yesterdayAmount == 'N/A') {
      this.percentInc = 'N/A'
      this.arrowUp = true
    } else if (this.todayAmount > this.yesterdayAmount) {
      this.percentInc = ((this.todayAmount - this.yesterdayAmount) / this.yesterdayAmount)
      this.arrowUp = true
    } else {
      this.percentDec = ((this.yesterdayAmount - this.todayAmount) / this.yesterdayAmount)
      this.arrowUp = false
    }
    
    if (this.yesterdayTotal == 'N/A') {
      this.percentInc = 'N/A'
      this.arrowUp = true
    } else if (this.todayTotal > this.yesterdayTotal) {
      this.percentIncAmt = ((this.todayTotal - this.yesterdayTotal) / this.yesterdayTotal)
      this.arrowUpAmt = true
    } else {
      this.percentDecAmt = ((this.yesterdayTotal - this.todayTotal) / this.yesterdayTotal)
      this.arrowUpAmt = false
    }
    var householdMtd = 0
    var amountMtd = 0
    for (var i = 0; i < data.length; i++) {
      householdMtd = householdMtd + data[i].total
      amountMtd = amountMtd + data[i].amount
    }
    this.householdMtd = householdMtd
    this.amountMtd = amountMtd
    this.isLoadedCards = false
  }
  
    // filter The Grid Data
    public dataStateChange(state: DataStateChangeEvent): void {
        this.state = state;
        this.gridCollectorData = process(this.uccCollector, this.state);
        this.gridCollectorDataNull = process(this.nullZoneData, this.state);
        if (state && state.group) {
            this.gridCollectorData = process(this.uccCollector, this.state);
            this.gridCollectorDataNull = process(this.nullZoneData, this.state);
        }
    }

    // Filter Data details
    onDateRangeChanged(dateRange) {
        if (dateRange.beginDate.day > 0) {
            this.defaultStartDate = dateRange.beginDate.year + "-" + dateRange.beginDate.month + "-" + dateRange.beginDate.day
            this.defaultEndDate = dateRange.endDate.year + "-" + dateRange.endDate.month + "-" + dateRange.endDate.day
            this.uccDailyCollectionEntityWise()
            this.uccDailyCollection()
            this.getTopPerformer()
        } else if (dateRange.beginDate.day == 0) {
            this.defaultStartDate = this.defaultStartDate
            this.defaultEndDate = this.defaultEndDate
            this.uccDailyCollectionEntityWise()
            this.uccDailyCollection()
            this.getTopPerformer()
        }
    }

    ngOnInit(): void {
        var ss = window.location.pathname.split("/")
        this.prjcd = ss[2]
        this.prjId = this.auth.getAuthentication().projectId
        this.uccDailyCollectionEntityWise();
        this.uccDailyCollection()
        this.getTopPerformer()
        this.collectionBycollectorName();
    }
}


// WEBPACK FOOTER //
// ./src/app/reports/uccReport/completeDashboard.component.ts